import { useState } from "react";
import { useChatContext } from "duck/ui/chat/contexts/useChatContext";
import { useTranslation } from "react-i18next";

import { filterThreadsBySearch, sortThreadsByDate } from "./utils";

export const useThreadList = () => {
  const { t } = useTranslation("duck");
  const {
    threads,
    currentThreadId,
    selectThread,
    isStreaming,
    isCreating,
    isSwitchingThread,
    createNewThread,
    deleteThread,
    setUseListThreadArgs,
    useListThreadArgs,
    isLoadingThreads,
  } = useChatContext();

  const [searchQuery, setSearchQuery] = useState("");

  const isDisabled = isStreaming || isCreating || isSwitchingThread;
  const hasThreads = threads && threads.length > 0;

  // Sort threads by created date descending (newest at top)
  const sortedThreads = sortThreadsByDate(threads);

  // Filter by search query (recomputed on every render when searchQuery changes)
  const filteredThreads = filterThreadsBySearch(
    sortedThreads,
    searchQuery,
    t("empty_chat")
  );

  const handleSearchChange = (query: string) => {
    setSearchQuery(query);
  };

  return {
    filteredThreads,
    currentThreadId,
    selectThread,
    isDisabled,
    hasThreads,
    searchQuery,
    handleSearchChange,
    createNewThread,
    deleteThread,
    setUseListThreadArgs,
    useListThreadArgs,
    isLoadingThreads,
  };
};
